import { createFileRoute } from "@tanstack/react-router";
import { DashboardLayout } from "@/projects/components/dashboard-layout";
import { SubmissionsPage } from "@/projects/components/submissions-page";

export const Route = createFileRoute("/admin/submissions")({
  head: () => ({ meta: [{ title: "Video Submissions — Admin" }] }),
  component: () => (
    <DashboardLayout role="admin" title="Video Submissions" breadcrumb={["Home", "Submissions"]}>
      <SubmissionsPage />
    </DashboardLayout>
  ),
});
